const mediaData = [
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Dramatic%20video%20thumbnail%20style%20with%20glowing%20play%20button%20center%2C%20dark%20moody%20background%20with%20crimson%20accents%2C%20cinematic%20composition%2C%20youtube%20thumbnail%20aesthetic%2C%20no%20text%20no%20people&width=600&height=380&seq=media-01&orientation=landscape',
    title: '深度解析：某顶流男星隐婚事件全时间线',
    duration: '15:42',
    views: '28.6 万',
    tag: '深度扒皮',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20with%20bright%20red%20play%20icon%2C%20split%20screen%20composition%2C%20dramatic%20lighting%2C%20entertainment%20news%20aesthetic%2C%20no%20text%20no%20people&width=600&height=380&seq=media-02&orientation=landscape',
    title: '两大网红撕逼直播完整录屏及分析',
    duration: '22:10',
    views: '45.2 万',
    tag: '现场直击',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20with%20glowing%20play%20symbol%2C%20luxurious%20red%20carpet%20scene%2C%20golden%20hour%20lighting%2C%20entertainment%20media%20style%2C%20cinematic%20vibe%2C%20no%20text%20no%20people&width=600&height=380&seq=media-03&orientation=landscape',
    title: '品牌解约风波：从声明到律师函全过程',
    duration: '18:35',
    views: '19.8 万',
    tag: '事件追踪',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20with%20big%20red%20play%20button%2C%20dramatic%20stage%20lighting%2C%20concert%20vibe%2C%20dark%20moody%20atmosphere%2C%20media%20aesthetic%2C%20no%20text%20no%20people&width=600&height=380&seq=media-04&orientation=landscape',
    title: '乐队主唱离场事件观众第一视角实拍',
    duration: '08:22',
    views: '62.1 万',
    tag: '第一现场',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20with%20play%20icon%20center%2C%20studio%20interview%20setup%2C%20warm%20professional%20lighting%2C%20podcast%20style%2C%20entertainment%20media%2C%20no%20text%20no%20people&width=600&height=380&seq=media-05&orientation=landscape',
    title: '黑料大赛编辑圆桌：今年最值得关注的十大八卦',
    duration: '35:18',
    views: '12.4 万',
    tag: '编辑精选',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">视频吃瓜</h2>
          <p className="mt-2 text-sm text-foreground-600">视频版吃瓜体验，深度解析带你了解事件全貌</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaData.slice(0, 2).map((item, i) => (
            <article key={i} className="lg:col-span-2 group cursor-pointer bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-accent-300/50 transition-all duration-300">
              <div className="grid grid-cols-1 md:grid-cols-5">
                <div className="md:col-span-3 relative overflow-hidden">
                  <img src={item.thumbnail} alt={item.title} className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-950/70 text-background-50 group-hover:bg-accent-500 transition-colors duration-200">
                      <i className="ri-play-fill text-2xl ml-1"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-background-950/80 text-background-50 text-xs whitespace-nowrap">{item.duration}</span>
                </div>
                <div className="md:col-span-2 p-5 flex flex-col justify-center">
                  <span className="text-xs text-accent-600 font-semibold">{item.tag}</span>
                  <h3 className="mt-1 text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug">{item.title}</h3>
                  <span className="mt-3 text-xs text-foreground-500">{item.views} 次播放</span>
                </div>
              </div>
            </article>
          ))}

          {mediaData.slice(2).map((item, i) => (
            <article key={i + 2} className="group cursor-pointer bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-accent-300/50 transition-all duration-300 flex flex-col">
              <div className="relative overflow-hidden">
                <img src={item.thumbnail} alt={item.title} className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-950/70 text-background-50 group-hover:bg-accent-500 transition-colors duration-200">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/80 text-background-50 text-xs whitespace-nowrap">{item.duration}</span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <span className="text-xs text-accent-600 font-semibold">{item.tag}</span>
                <h3 className="mt-1 text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug flex-1">{item.title}</h3>
                <span className="mt-2 text-xs text-foreground-500">{item.views} 次播放</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}